import React from "react"
import { Pencil } from "react-bootstrap-icons"

const PostEditButton = ({ setShowEditForm }) => {
  return (
    <div>
      <>
        <button
          onClick={(e) => setShowEditForm(true)}
          className="text-sm focus:outline-none"
        >
          <Pencil className="inline align-baseline mx-1" size={11} />
          Edit
        </button>
      </>
    </div>
  )
}

export default PostEditButton
